// extracted by mini-css-extract-plugin
export default {"textArea":"TextArea_textArea__-oS8Y","textAreaBorderError":"TextArea_textAreaBorderError__B9HHR","textAreaError":"TextArea_textAreaError__klVwh"};